import { STATUS } from "@/constant/statusConstants";
import * as Yup from "yup";

const PlayerCareerSchema = () => {
  Yup.object().shape({
    team_id: Yup.number().label("Team").required(),
    term_id: Yup.number().label("Term").required(),
    player_id: Yup.number().label("Player").required(),
    status: Yup.string()
      .label("Status")
      .required()
      .oneOf(Object.values(STATUS)),
  });
};

export default PlayerCareerSchema;
